import { isLaunchpadSupported, launchpadDefinitions } from '@/constants/launchpads';

import { Avatar, AvatarProps } from '../Avatar';

export type LaunchpadAvatarProps = Omit<AvatarProps, 'rounded'> & {
  /**
   * ID of the launchpad used to launch the token.
   */
  id: string;
};

export const launchpadAvatarRadius = '32%';

export const LaunchpadAvatar = (props: LaunchpadAvatarProps) => {
  const { id, size = 24, ...otherProps } = props;

  const fallbackIconSrc = '/images/chains/none.svg';
  const launchpadIconSrc = isLaunchpadSupported(id)
    ? launchpadDefinitions[id].logo
    : fallbackIconSrc;

  return (
    <Avatar
      src={launchpadIconSrc}
      fallbackSrc={fallbackIconSrc}
      radius={launchpadAvatarRadius}
      size={size}
      {...otherProps}
    />
  );
};
